<template>
  <div >
    <div class=" is-fullwidth">
      <div class="buttons is-pulled-left" >
        <button class="button " :disabled="loading==true" v-bind:class="{'is-success': cutting_location_id == row.id}" v-for="row in cutting_rooms" :key="row.id" @click="cutting_location_id=row.id">{{ row.name }}</button>
        <button class="button" :disabled="loading==true" style="" @click="cutting_location_id='allset'" v-bind:class="{'is-success': cutting_location_id == 'allset'}">All Locations</button>
      
        <button class="button is-light">{{ filteredOrders.length }} orders</button>
        <button class="button is-light">{{this.total_garment_cut}} / {{ this.total_garments }} garments</button>
      </div>
      <div class="is-pulled-right">
        <button class="button is-warning" @click="exportXLS()">Export to Excel</button>
      </div>
    </div>

    <div class="notification is-info" v-if="loading == true " style="clear:both">Loading orders ...</div>
    
    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" v-if="loading == false">
    	<thead>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th @click="updateSortOrder('orderdate')" style="cursor:pointer">Ordered
            <span v-if="order_by === 'orderdate DESC'">&#8595;</span>
            <span v-if="order_by === 'orderdate ASC'">&#8593;</span>
          </th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Required
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          
          <th>Qty</th>
          <th>Cutting Location</th>
          <th>Makeup Location</th>
          <th >&nbsp;</th>
          <th >&nbsp;</th>
          <th >&nbsp;</th>
    	</thead>
    	<tbody>
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
               <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.orderdate}}</td>
          <td>{{order.deliverydate}}</td>
          <td>{{ order.total_qty }}</td>
          <td>{{ order.cutting_location_name }}</td>
          <td>{{ order.makeup_location_name }}</td>
          
              <td >
                  <button class="button is-small " :class="{'is-success' : order.marker_received == 1}" @click="updateMarker(order)" :disabled="working===true" >Marker Received</button>
              </td>
              <td >
                  <button class="button is-small " :class="{'is-success' : order.fabric_received == 1}" @click="updateFabric(order)" :disabled="working===true" >Fabric Received</button>
              </td>
              <td >
                  <button class="button is-small " :class="{'is-success' : order.cutsew_cutting == 1, 'is-warning' : order.cutsew_cuttings.length > 0}" :disabled="working===true" @click="showCompleteError()">Cutting Complete ({{ order.cutsew_cuttings_qty }}/{{  order.total_qty }})</button>
              </td>
			</tr>
    	</tbody>
    </table>

    <table class="" id="orderstable-export" v-if="loading == false" style="display:none">
    	<thead>
        <tr>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th>Ordered</th>
          <th >Required
            
          </th>
          <th>Qty Cut</th>
          <th>Total Qty</th>
          <th>Cutting Location</th>
          <th>Makeup Location</th>
          <th >Marker Received</th>
          <th >Fabric Received</th>
          <th >Cutting Complete</th>
        </tr>
    	</thead>
    	<tbody>
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
               <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.orderdate_raw}}</td>
          <td>{{order.deliverydate_raw}}</td>
          <td>{{  order.cutsew_cuttings_qty }}</td>
          <td>{{ order.total_qty }}</td>
          <td>{{ order.cutting_location_name }}</td>
          <td>{{ order.makeup_location_name }}</td>
          
              <td >
                  <span v-if="order.marker_received == 1" >Yes</span>
              </td>
              <td >
                <span v-if="order.fabric_received == 1" >Yes</span>
              </td>
              <td >
                <span  v-if="order.cutsew_cutting == 1">Yes</span>
                <span v-if="order.cutsew_cutting == 0 && order.cutsew_cuttings.length > 0">Part</span>
                  
              </td>
			</tr>
    	</tbody>
    </table>
    
    
    
  </div>
</template>

<script>
import XLSX from 'xlsx';

import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      cutting_rooms: [],
      makeuplocations: [],
      order_by: 'deliverydate ASC',
      cutting_location_id: 'allset',
      limit: ''
    }
  },
   methods: {
    exportXLS() {
		 var wb = XLSX.utils.table_to_book(document.getElementById('orderstable-export'), {sheet:"Cutting Overview"});
		 XLSX.writeFile(wb, 'cutting_overview.xlsx')

	 },
    showCompleteError() {
        alert("This button does not action anything. The button will go green when all cutting has been scanned.")
    },
      async getOrders() {
        this.loading=true
        OrderService.getCutSewInProgressOrders(this.accessToken, this.limit, this.order_by, this.cutting_location_id, 0, 0)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
       async updateMarker(order) {
        this.working = true
        
        var order_id = order.orderID
       

        var formdata = { 
            _method: 'patch',
             marker_received: 1
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            this.working = false
            //console.log(response)
            order.marker_received = 1
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },   
    async updateFabric(order) {
        this.working = true
        
        var order_id = order.orderID
       

        var formdata = { 
            _method: 'patch',
             fabric_received: 1
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            this.working = false
            //console.log(response)
            order.fabric_received = 1
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },    
    async processOrder(order) {
        this.working = true

        var order_id = order.orderID

        var formdata = { 
            _method: 'patch',
             in_progress: 1,
             makeup_location_id: order.makeup_location_id
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            order.in_progress = 1
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async getRanges() {
        UtilityService.getSimpleApiData(this.accessToken, "ranges").then(
               response => this.ranges = response 
            );
      },
      async getCuttingRooms() {
        UtilityService.getSimpleApiData(this.accessToken, "locations?cutting=1").then(
               response => this.cutting_rooms = response 
            );
      },
    
  },
  computed : {
      filteredOrders: function () {
       
        /*let filteredOrders =  this.orders.filter(function(u) {
            if(  u.in_progress == 0) 
            {
              return 1
            }
          })*/
          let filteredOrders = this.orders

          return filteredOrders
       
     },
     total_garments: function () {
        return this.filteredOrders.reduce((total, order) => total + order.total_qty, 0);
     },
     total_garment_cut: function () {
        return this.filteredOrders.reduce((total, order) => total + order.cutsew_cuttings_qty, 0);
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getCuttingRooms();
        });
  },
 
  mounted() {
    if (localStorage.offshore_cutting_location_id) {
      this.cutting_location_id = localStorage.offshore_cutting_location_id;
    }
    else{
      this.cutting_location_id = 'allset'
    }
      
  },
  watch: {
    'cutting_location_id'() {
      this.orders = []
      localStorage.offshore_cutting_location_id = this.cutting_location_id
      this.getOrders();
    },
    
  }
}


</script>

